import encryptServer from '@/request/encryptRequest.js';

// 商品sku档案
export const skuPageList = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/pageList', data);

export const addSku = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/add', data);

export const deleteSku = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/delete', data);

// 查询商品Sku详情
export const skuDetail = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/detail', data);

// 启用或禁用
export const enableOrDisable = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/enableOrDisable', data);

export const updateSku = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/baseSku/update', data);

// 操作日志分页列表
export const operationLog = data => encryptServer.post('/xiaozi-xms/wireless/saas/operationLog/pageList', data);

// 设备列表
export const getDevicePageList = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/device/pageList', data);

// 设备列表 (1xie)
export const getDevicePageList1xie = data => encryptServer.post('/xiaozi-xms/wireless/saas/1xie/device/pageList', data);

// 品牌列表
export const getBrandPageList = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/brand/pageList', data);

// 品牌列表 (1xie)
export const getBrandPageList1xie = data => encryptServer.post('/xiaozi-xms/wireless/saas/1xie/brand/pageList', data);

// 商品定价模板
export const goodsPriceTemplate = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/goodsPriceTemplate/pageList', data);
